// Datas de evento (startat/endat) são DIA DE CALENDÁRIO gravado como meia-noite
// UTC — por isso as telas já leem dia/mês/ano com getUTC*.
//
// O status e o texto relativo ("Amanhã", "Há 2 dias") não podem subtrair esse
// instante do `new Date()` local: às 22h em BRT (UTC-3) já é o dia seguinte em
// UTC, então um evento do dia 15 aparecia como "Amanhã" ainda no dia 13, e um
// evento de dois dias virava "Encerrado" às 21h do último dia. A comparação
// aqui é sempre entre DIAS DE CALENDÁRIO: o do evento (lido em UTC) contra o
// de quem está olhando a tela (lido no fuso local).

export const DIA_MS = 864e5

// Dia de calendário do valor gravado, normalizado para comparação.
export const eventDay = (value) => {
  if (!value) return null
  const d = new Date(value)
  if (isNaN(d.getTime())) return null
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())
}

// Hoje, pelo calendário local de quem está olhando a tela.
export const today = () => {
  const n = new Date()
  return Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
}

// 'scheduled' antes do primeiro dia, 'done' depois do último, 'live' no meio
// (inclusive no primeiro e no último dia). Evento sem datas continua 'live',
// como era antes.
export const statusOf = (ev) => {
  if (!ev) return 'idle'
  const hoje = today()
  const ini = eventDay(ev.startat)
  const fim = eventDay(ev.endat)
  if (fim !== null && hoje > fim) return 'done'
  if (ini !== null && hoje < ini) return 'scheduled'
  return 'live'
}

// Tempo relativo amigável, em pt-BR, conforme o status do evento.
export const relativeLabel = (ev) => {
  if (!ev) return ''
  const st = statusOf(ev)
  if (st === 'live') return 'Ao vivo agora'
  const hoje = today()

  if (st === 'scheduled') {
    const ini = eventDay(ev.startat)
    if (ini === null) return 'Em breve'
    const d = Math.round((ini - hoje) / DIA_MS)
    if (d <= 0) return 'Começa hoje'
    if (d === 1) return 'Amanhã'
    if (d < 7) return `Em ${d} dias`
    if (d < 14) return 'Em 1 semana'
    if (d < 60) return `Em ${Math.round(d / 7)} semanas`
    return `Em ${Math.round(d / 30)} meses`
  }

  const fim = eventDay(ev.endat)
  if (fim === null) return 'Encerrado'
  const d = Math.round((hoje - fim) / DIA_MS)
  if (d <= 0) return 'Encerrou hoje'
  if (d === 1) return 'Ontem'
  if (d < 30) return `Há ${d} dias`
  if (d < 60) return 'Há 1 mês'
  if (d < 365) return `Há ${Math.round(d / 30)} meses`
  const anos = Math.round(d / 365)
  return anos === 1 ? 'Há 1 ano' : `Há ${anos} anos`
}
